import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { fetchProductAvailabilityFailure } from 'store/actions/products/productAvailibity';
import { put, takeLatest } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* fetchProductAvailabilityAsync({ payload }) {
    const { callback, formValues, id } = payload;
    let params = { ...formValues };

    try {
        const url = `${ config.getApiBaseUrl() }/products/${ id }/availability`;

        const response = yield apiClient.read(url, params);

        yield callback({
            success: response,
        });
    } catch (error) {
        yield put(fetchProductAvailabilityFailure(error));

        yield callback({
            error: error.response.message,
        });
    }
}

function* failureMessage({ error }) {
    yield put(showNotification(error.response.message, 'warning'));
}

export default function* productAvailabilitySagas() {
    yield [
        takeLatest('FETCH_PRODUCT_AVAILABILITY', fetchProductAvailabilityAsync),
        takeLatest('FETCH_PRODUCT_AVAILABILITY_FAILURE', failureMessage),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/productAvailabilitySagas.js